import { Component, Input, TemplateRef, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Button } from 'src/app/_models/modal/Button';

@Component({
	selector: 'app-modal-kcs',
	templateUrl: './kcs-modal.component.html',
	styleUrls: ['./kcs-modal.component.css'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class ModalKcsComponent {
	@Input() titolo: string = '';
	@Input() testo: string = '';
	@Input() severity: 'success' | 'info' | 'warn' | 'danger' | 'help' | 'primary' | 'secondary' | 'contrast' | null | undefined;
	@Input() buttons: Button[] = [];
	@Input() content: TemplateRef<any> | null = null;
	@Input() eyebrow: string = '';
	@Input() subtitle: string = '';
	@Input() icon: string = '';

	constructor(public activeModal: NgbActiveModal) {}

	openModal(titolo: string, testo: string, buttons: Button[], severity: 'success' | 'info' | 'warn' | 'danger' | 'help' | 'primary' | 'secondary' | 'contrast' | null | undefined = 'info', content?: TemplateRef<any>): void {
		this.titolo = titolo;
		this.testo = testo;
		this.buttons = buttons;
		this.severity = severity;
		this.content = content || null;
	}

	close(): void {
		this.activeModal.close();
	}

	isOutlined(b: Button): boolean {
		const cls = (b?.class || '').toLowerCase();
		return cls.includes('outlined') || cls.includes('secondary') || /annulla|cancel|chiudi/i.test(b?.label || '');
	}

	doAction(action: any): void {
		if (action) {
			action();
		}
		//La modal va chiusa manualmente e non dopo ogni singola azione sui pullsanti
		// this.close();
	}
}
